import { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { subscribeToNewsletter } from "../page/actions";

interface NewsletterFormProps {
    selectedGroceriesCount: number;
    selectedGroceryIds: number[];
}

export function NewsletterForm({
    selectedGroceriesCount,
    selectedGroceryIds,
}: NewsletterFormProps) {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState<
        "idle" | "loading" | "success" | "error"
    >("idle");
    const [message, setMessage] = useState("");

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        setStatus("loading");

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailRegex.test(email)) {
            setStatus("error");
            setMessage("Invalid email.");
            return;
        }
        const result = await subscribeToNewsletter(email, selectedGroceryIds);

        console.log("handleSubmit", { result });

        if (result.success) {
            setStatus("success");
            setMessage(result.data.message || "Thanks for subscribing!");
            setEmail("");
        } else {
            setStatus("error");
            setMessage(
                result.data.error || "Something went wrong. Please try again.",
            );
        }
    }

    return (
        <form onSubmit={handleSubmit} className="">
            <div className="flex gap-2">
                <Input
                    type="email"
                    placeholder="kari@nordmann.no"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="flex-1 max-w-[50%]"
                />
                <div className="max-w-[50%] mr-auto">
                    <Button
                        outline
                        label={
                            status === "loading"
                                ? "Melder deg opp..."
                                : "Meld meg på!"
                        }
                        disabled={
                            status === "loading" || selectedGroceriesCount === 0
                        }
                        onClick={(e) => handleSubmit(e)}
                    />
                </div>
            </div>
            {message && (
                <p
                    className={`text-sm ${status === "success" ? "text-green-600" : "text-red-600"}`}
                >
                    {message}
                </p>
            )}
        </form>
    );
}
